import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reading-words',
  templateUrl: './reading-words.component.html',
  styleUrls: ['./reading-words.component.scss']
})
export class ReadingWordsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
